import PropTypes from "prop-types";
import styled from "styled-components";
import range from "lodash/range";
import "react-alice-carousel/lib/alice-carousel.css";
import Testimonial from "components/CustomComponent/TestimonialCarousel/Testimonial";
import Carousel from "components/CustomComponent/TestimonialCarousel/Carousel";

const Container = styled.div`
  width: 100vw;
  background: ${({ theme }) => theme.colors["mint3"]};
`;

/**
 * Testimonial carousel version that doesn't include any extra content (headers, etc.)
 *
 * @component
 * @param {Object} props
 * @param {String} [props.className]
 * @param {Array} props.items
 */
function TestimonialCarousel({ className, items }) {
  // Triple slides to make loop more seamless (copy of prev note)
  let testimonialSlides = [];
  range(3).map((i) =>
    items?.map((t) =>
      testimonialSlides.push(
        <Testimonial
          key={`${i}-${t.id}`}
          author={t.author}
          content={t.content}
          image={t.image}
        />
      )
    )
  );

  return (
    <Container className={className}>
      <Carousel items={testimonialSlides} />
    </Container>
  );
}

TestimonialCarousel.defaultProps = {};
TestimonialCarousel.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
};

export default TestimonialCarousel;
